module.exports = __webpack_public_path__ + "static/egg-startup-sound-0fe3f543664d5ec034531d2949f8b722.mp3";